<template>
    <ul @click.stop="" class="dropdown-menu extention-dropup enhance-dropdown">
        <li>
            <strong>Enhance preset:</strong>
            <select class="enhance-select form-control input-sm" @change="onChange($event.target.value)">
                <option v-for="item in presets" :value="item.id">
                    {{ item.name }}
                </option>
            </select>
            <a href="//ritekit.com/enhance/image" target="_blank" class="btn btn-default"><i class="fa fa-cog"></i></a>
        </li>
        <li>
            <input type="checkbox" v-model="options.extractImage"> Extract images from links
        </li>
        <li>
            <input type="checkbox" v-model="options.quoteImage"> Create image/GIF from template
            <select class="enhance-select form-control input-sm" v-if="currentSet" v-model="options.quoteImageFrom">
                <option v-for="item in currentSet.quoteImageList" :value="item.id">
                    {{ item.name }}
                </option>
            </select>
            <a href="//ritekit.com/enhance" target="_blank" class="btn btn-default"><i class="fa fa-cog"></i></a>
        </li>
        <li>
            <input type="checkbox" v-model="options.autoHashtags"> Auto-hashtag
        </li>
        <li>
            Max <input type="number" class="form-control number-input input-sm" v-model="options.maxHashtags">
            hashtags placed
            <select class="enhance-select form-control imput-sm" v-model="options.hashtagPosition">
                <option value="auto">anywhere</option>
                <option value="end">at the end</option>
            </select>
        </li>
        <li>
            <input type="checkbox" v-model="options.autoEmoji">  Auto-emojify <sup>BETA</sup>
        </li>
        <li>
            <input type="checkbox" v-model="options.shortLink">  Place my ad on links
            <select class="enhance-select form-control input-sm" v-if="currentSet" v-model="options.shortLinkWith">
                <option v-for="item in currentSet.ctaList" :value="item.id">
                    {{ item.name }}
                </option>
            </select>
            <a href="//rite.ly/dashboard" target="_blank" class="btn btn-default"><i class="fa fa-cog"></i></a>
        </li>
        <li>
            <input type="checkbox" v-model="options.twitterHandler">  Append author's Twitter handle
        </li>
        <li>
            <input type="checkbox" v-model="options.appendText">  Append
            <input type="text" placeholder="text, #hashtag or 😊" class="enhance-select form-control" v-model="options.appendTextWith">
        </li>
        <li>
            <input type="checkbox" v-model="options.replaceText">  Replace (default)
        </li>
    </ul>
</template>

<script>
    import axios from 'axios'

    export default {
        name: 'EnhanceDropdown',
        data () {
            return {
                presets: null,
                currentSet: null,
                setsCache: [],
                options: this.prepareOptions({})
            }
        },
        methods: {
            onChange (id) {
                const self = this
                this.loadSet(id).then((set) => {
                    console.log(set)
                    self.currentSet = set
                    self.options = self.prepareOptions(set)
                })
            },
            prepareOptions (settings) {
                return {
                    extractImage: settings.extractImage || false,
                    quoteImage: settings.quoteImage || false,
                    quoteImageFrom: settings.quoteImageFrom || null,
                    autoHashtags: settings.autoHashtags || false,
                    autoEmoji: settings.autoEmoji || false,
                    shortLink: settings.shortLink || false,
                    shortLinkWith: settings.shortLinkWith || null,
                    twitterHandler: settings.twitterHandler || false,
                    appendText: settings.appendText || false,
                    appendTextWith: settings.appendTextWith || '',
                    replaceText: settings.replaceText || false,
                    replaceTextWith: settings.enhanceReplaceTextWith || [],
                    maxHashtags: settings.maxHashtags || 2,
                    hashtagPosition: settings.hashtagPosition || 'auto'
                }
            },
            loadPresets (force = false) {
                const self = this
                return new Promise((resolve, reject) => {
                    if (self.presets && !force) {
                        resolve(self.presets)
                    }
                    axios.get('/api/v1/enhance/sets').then((response) => {
                        const presets = response.data.sets
                        self.presets = presets
                        resolve(presets)
                    }).catch((err) => {
                        reject(err)
                    })
                })
            },
            loadSet (id, force = false) {
                const self = this
                return new Promise((resolve, reject) => {
                    if (self.setsCache[id] && !force) {
                        resolve(self.setsCache[id])
                    }
                    axios.get('/api/v1/enhance/sets/' + id).then((response) => {
                        const settings = response.data.settings
                        self.setsCache[id] = settings
                        resolve(settings)
                    }).catch((err) => {
                        reject(err)
                    })
                })
            },
            getEnhanceOptions () {
                return this.options
            }
        },
        created () {
            const self = this
            this.loadPresets().then((presets) => {
                console.log(presets)
                self.onChange(presets[0].id)
            })
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .enhance-dropdown {
        padding: 10px 20px;
        width:500px;
        line-height: 175%;
    }
    .enhance-select {
        width: 170px;
        display: inline-block;
    }
    .btn {
        display: inline-block;
        vertical-align: top;
    }
    .number-input {
        width: 60px;
        display: inline-block;
    }
</style>



// WEBPACK FOOTER //
// src/components/EnhanceDropdown.vue